/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditFinancialAdvisorCommand } from '../../models/edit-financial-advisor-command';
import { FinancialAdvisorDetailsDtoApiResponse } from '../../models/financial-advisor-details-dto-api-response';

export interface EditFinancialAdvisorAsync$Params {
  id: number;
      body?: EditFinancialAdvisorCommand
}

export function editFinancialAdvisorAsync(http: HttpClient, rootUrl: string, params: EditFinancialAdvisorAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialAdvisorDetailsDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, editFinancialAdvisorAsync.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FinancialAdvisorDetailsDtoApiResponse>;
    })
  );
}

editFinancialAdvisorAsync.PATH = '/api/financial-advisor/{id}';
